
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#4B62C1"}},[_c('path',{attrs:{"d":"M14.999 11.625l-.002 3.935c0 .15.06.293.165.398l2.815 2.815.796-.796-2.651-2.65.002-3.702h-1.125z"}}),_c('path',{attrs:{"d":"M16.125 7.125c-3.96 0-7.236 2.94-7.785 6.75H6l2.813 2.813 2.812-2.813H9.477c.538-3.187 3.31-5.625 6.648-5.625a6.757 6.757 0 016.75 6.75 6.757 6.757 0 01-6.75 6.75 6.715 6.715 0 01-5.323-2.598l-.886.692a7.834 7.834 0 006.209 3.031C20.467 22.875 24 19.342 24 15c0-4.342-3.533-7.875-7.875-7.875z"}})]),_c('rect',{attrs:{"x":".5","y":".5","width":"29","height":"29","rx":"4.5","stroke":"#737882"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(6 6)","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    